export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        display: 'inline-flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_1000,
        border_width: FOUNDATIONS.border_100,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_static_50,
        background_size: 'cover',
        background_position: 'center',
        background_repeat: 'no-repeat',
        overflow: 'hidden',
    },
});
//# sourceMappingURL=commonStyles.js.map